import CourseCertificate from '@/components/course/course-certificate';
import CourseStats from '@/components/course/course-stats';
import { themeSlug } from '@/constants/environment';
import { useAuth, useCourses } from '@/providers';

export default function ProgressTab() {
  const { selectedCourse } = useCourses();
  const { isLoggedIn } = useAuth();

  if (!selectedCourse || !isLoggedIn) return null;

  const { id, testAt, type } = selectedCourse;
  const isTest = type === 'Test';

  return (
    <>
      <CourseStats courseId={id} testAt={testAt} />
      {themeSlug === 'mympu' && !isTest && <CourseCertificate />}
    </>
  );
}
